import { siteContent } from '@/mocks/pt/siteContent';
import { mainSiteUrl } from '@/mocks/pt/categories';

export default function HeroSection() {
  const { hero } = siteContent;

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20flat%20lay%20collage%20with%20white%20sneakers%20grey%20hoodie%20black%20cap%20leather%20belt%20and%20watch%20on%20light%20grey%20concrete%20surface%20bright%20studio%20lighting%20editorial%20aesthetic%20harmonious%20composition%20subtle%20shadows%20minimal%20style&width=1600&height=900&seq=hero-bg-v2-2026&orientation=landscape"
          alt="CSSBuy Spreadsheet - Produtos verificados"
          title="CSSBuy Spreadsheet produtos"
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
        {/* Dark overlay for text contrast */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24 text-center">
        <div className="max-w-4xl mx-auto">
          {/* H1 */}
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-4">
            {hero.h1Line1}
            <br />
            <span className="text-accent-300">{hero.h1Line2}</span>
          </h1>

          {/* Subtitle */}
          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-6 leading-relaxed">
            {hero.subtitle}
          </p>

          {/* Feature Tags */}
          <div className="flex flex-wrap items-center justify-center gap-2 mb-8">
            {hero.featureTags.map((tag, i) => (
              <span
                key={i}
                className="px-3 py-1.5 text-xs font-medium bg-white/15 backdrop-blur-sm text-white rounded-full border border-white/20 whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>

          {/* Description */}
          <p className="text-sm md:text-base text-white/70 max-w-3xl mx-auto mb-10 leading-relaxed">
            {hero.description}
          </p>

          {/* Trust Bar */}
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-5 mb-10">
            {hero.trustItems.map((item, i) => (
              <div key={i} className="flex items-center gap-1.5 text-xs md:text-sm text-white/80 whitespace-nowrap">
                <i className="ri-checkbox-circle-fill text-accent-400 text-sm w-4 h-4 flex items-center justify-center"></i>
                <span>{item}</span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-900 hover:bg-foreground-800 text-white font-semibold text-sm rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shopping-bag-3-line text-lg w-5 h-5 flex items-center justify-center"></i>
              {hero.ctaMain}
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white font-medium text-sm rounded-lg border border-white/30 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-flashlight-line text-lg w-5 h-5 flex items-center justify-center"></i>
              {hero.ctaSecondary}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}